import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CaptainWalletService {
  constructor() {}

  /**
   * La configuration CaptainWallet est propre à chaque environnement : sans elle,
   * l'URL générée serait invalide. On préfère masquer les entrées Wallet plutôt
   * que de proposer un lien ou un QR code qui ne fonctionnerait pas.
   */
  isConfigured(): boolean {
    return !!environment.apis?.captainWallet?.url;
  }

  generateUrl(integration3_id: string, tag: string = 'default'): string{
    return environment.apis.captainWallet.url +
      environment.apis.captainWallet.campaignId +
      '?user[identifier]=' + integration3_id +
      '&channel=' + environment.apis.captainWallet.channel +
      '&tag=' + tag;
  }
}
